import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import AlertProvider from "./contexts/AlertContext";
import { CanvasProvider } from "./contexts/CanvasContext";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { PropertyProvider } from "./contexts/PropertyContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <AlertProvider>
          <CanvasProvider>
            <PropertyProvider>
              <DndProvider backend={HTML5Backend}>
                <App />
              </DndProvider>
            </PropertyProvider>
          </CanvasProvider>
        </AlertProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
